import React, { useRef } from "react";
import { extractFirstQueryParam } from "domains/commons/misc";
import BlendAddConceptTabs from "domains/models/components/Blend/BlendCreation/BlendAddConceptTabs";
import BlendCategoriesView from "domains/models/components/Blend/BlendCreation/BlendCategoriesView";
import BlendLayout from "domains/models/components/Blend/BlendCreation/BlendLayout";
import BlendModalHeader from "domains/models/components/Blend/BlendCreation/BlendModalHeader";
import BlendShowConcept from "domains/models/components/Blend/BlendCreation/BlendShowConcept";
import useRouter from "domains/navigation/hooks/useRouter";

import { Flex } from "@chakra-ui/react";

export default function CreateBlend() {
  const router = useRouter();
  const contentScrollRef = useRef<HTMLDivElement>(null);

  const selectedModelId = extractFirstQueryParam(router.query.selectedModelId);
  const categoryId = extractFirstQueryParam(router.query.categoryId);
  const subCategoryId =
    categoryId !== undefined
      ? extractFirstQueryParam(router.query.subCategoryId)
      : undefined;

  return (
    <BlendLayout contentScrollRef={contentScrollRef}>
      {(!!selectedModelId && (
        <BlendShowConcept
          categoryId={categoryId}
          subCategoryId={subCategoryId}
          modelId={selectedModelId}
          contentScrollRef={contentScrollRef}
        />
      )) ||
        (!!categoryId && (
          <BlendCategoriesView
            categoryId={categoryId}
            subCategoryId={subCategoryId}
            contentScrollRef={contentScrollRef}
          />
        )) || (
          <Flex direction="column" w="full" p={6}>
            <BlendModalHeader />
            <BlendAddConceptTabs contentScrollRef={contentScrollRef} />
          </Flex>
        )}
    </BlendLayout>
  );
}
